const methods = [
  {
    icon: 'ri-gamepad-line',
    title: 'Бизнес-игры',
    desc: 'Командные игры, которые моделируют реальные бизнес-ситуации: конкуренция, переговоры, принятие решений под давлением.',
  },
  {
    icon: 'ri-trophy-line',
    title: 'Стратегические игры',
    desc: 'Комплексные симуляции, где команды разрабатывают стратегию, распределяют ресурсы и соревнуются за результат.',
  },
  {
    icon: 'ri-mic-line',
    title: 'Фасилитация',
    desc: 'Структурированные сессии с профессиональным фасилитатором для решения сложных вопросов и принятия решений.',
  },
  {
    icon: 'ri-team-line',
    title: 'Командные проекты',
    desc: 'Реальные проекты с четкими целями, сроками и метриками. Команда учится работать вместе на практике.',
  },
  {
    icon: 'ri-dashboard-3-line',
    title: 'Симуляции',
    desc: 'Моделирование кризисных ситуаций, изменений стратегии или внедрения новых процессов в безопасной среде.',
  },
  {
    icon: 'ri-briefcase-4-line',
    title: 'Деловые игры',
    desc: 'Ролевые игры на основе реальных кейсов компании. Участники отрабатывают навыки в приближенных к жизни условиях.',
  },
  {
    icon: 'ri-exchange-line',
    title: 'Переговорные упражнения',
    desc: 'Тренировка навыков ведения переговоров, разрешения конфликтов и поиска win-win решений.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Командные кейсы',
    desc: 'Анализ реальных кейсов компании. Команда вместе находит решения и учится мыслить системно.',
  },
  {
    icon: 'ri-loop-left-line',
    title: 'Рефлексия',
    desc: 'Глубокий разбор опыта: что сработало, что нет, почему так произошло. Ключевой элемент обучения.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Совместное решение проблем',
    desc: 'Команда решает реальные проблемы компании, применяя структурированные методики и фасилитацию.',
  },
];

export default function ModernMethods() {
  return (
    <section id="methods" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Современные методы командообразования
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Развлекательные мероприятия — прошлый век. Сегодня эффективное командообразование строится на методах, которые дают реальные инсайты и меняют культуру.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {methods.map((m, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-200 hover:border-teal-300 hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${m.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{m.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}